<!-- @ts-nocheck -->
<template>
  <q-select
    v-if="isComponentEnabled"
    v-bind="$attrs"
    :modelValue="selectedOptions"
    :stack-label="!dense"
    use-input
    :hide-selected="multiple !== ''"
    fill-input
    filled
    emit-value
    :clearable="!disabled"
    :dense="dense"
    input-debounce="50"
    option-value="value"
    option-label="label"
    :multiple="multiple == ''"
    :use-chips="multiple == ''"
    ref="IstFormSearch"
    :options="curOptions"
    :disabled="disabled"
    :disable="disabled"
    :readonly="disabled"
    :label="getLabel()"
    :error="disabled ? false : error"
    :error-message="disabled ? '' : errorMessage"
    :class="{ showerror: error }"
    :loading="loading"
    style="padding-bottom: 0"
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="false"
    popup-content-style="z-index: 100000"
    @update:modelValue="
      localvalue = $event;
      updateValue();
    "
    :input-style="inputStyle"
    @filter="defaultfilter"
  >
    <template v-slot:option="scope">
      <slot name="option" v-bind="scope">
        <dtpItem v-bind="scope.itemProps">
          <dtpItemSection>
            <dtpItemLabel>
              {{ scope.opt.label }}<dtpIcon v-if="scope.opt.hidden"
                                            name="mdi-eye-off"
              /></dtpItemLabel>
            <dtpItemLabel v-if="scope.opt.sublabel" caption>{{ scope.opt.sublabel }}</dtpItemLabel>
          </dtpItemSection>
        </dtpItem>
      </slot>
    </template>

    <template v-slot:no-option>
      <dtpItem>
        <dtpItemSection class="text-italic text-grey">{{ noOptionsText }}</dtpItemSection>
      </dtpItem>
    </template>
  </q-select>

  <CuiSelect
    v-else
    v-bind="$attrs"
    :modelValue="localvalue"
    :options="options"
    optionLabel="label"
    optionValue="value"
    :label="getLabel()"
    :disabled="disabled"
    :invalid="error"
    :error="errorMessage"
    filterable
    clearable
    :placeholder="label || 'Vælg en option...'"
    @update:modelValue="
      localvalue = $event;
      updateValue();
    "
  />
</template>
<script setup lang="ts">
// @ts-nocheck
import { ref, watch, computed, onMounted } from "vue";
import { QSelect } from "quasar";
import { searchPredicate } from "../utils/searchUtils";
import { CuiSelect } from "@ist/commonui-components";

import { useFeatureFlags } from "@/composables/useFeatureFlags";

const { isEnabled } = useFeatureFlags();
const isComponentEnabled = computed(() => isEnabled("IstFormSearch"));

export type optiontype = { label: string; sublabel: string; value: any; icon: string };

defineOptions({ name: "IstFormSearch" });

const props = withDefaults(
  defineProps<{
    validation?: any;
    modelValue?: any;
    disabled?: boolean;
    label?: string;
    options: Array<optiontype>;
    error?: boolean;
    dense?: boolean | string;
    errorMessage?: string;
    multiple?: string;
    inputStyle?: any;
    loading?: boolean;
    noOptionsText?: string;
  }>(),
  {
    disabled: false,
    error: false,
    dense: false as any,
    multiple: "false",
    loading: false,
    noOptionsText: "Der er ingen valgmuligheder der matcher det indtastede"
  }
);

const emit = defineEmits<{
  input: [value: any];
  change: [value: any];
  "update:modelValue": [value: any];
}>();

const curOptions = ref<Array<optiontype>>([]);
const localvalue = ref<any>(null);
const selectRef = ref<QSelect | null>(null);

const selectedOptions = computed<any>({
  get() {
    if (props.multiple === "") {
      if (localvalue.value) {
        return props.options.filter((value: optiontype) => {
          return localvalue.value.some((localVal: any) => objectComparer(localVal, value.value));
        });
      }
      return [];
    } else {
      return props.options.find((value: optiontype) => localvalue.value == value.value);
    }
  },
  set(selection: any) {
    if (props.multiple === "") {
      if (Array.isArray(selection)) {
        localvalue.value = selection.map((value: optiontype) => value.value);
      } else {
        localvalue.value = null;
      }
      selectRef.value?.updateInputValue("", false);
    } else {
      localvalue.value = selection?.value;
    }
    updateValue();
  }
});

function updateValue() {
  emit("input", localvalue.value);
  emit("change", localvalue.value);
  emit("update:modelValue", localvalue.value);
}

watch(
  () => props.modelValue,
  (val: any) => {
    if (val) {
      try {
        localvalue.value = val;
      } catch {
        localvalue.value = undefined;
      }
    } else {
      localvalue.value = undefined;
    }
  }
);

onMounted(() => {
  curOptions.value = props.options;
  if (props.modelValue) {
    localvalue.value = props.modelValue;
  }
});

function getLabel() {
  if (!props.label) return null;
  let s: string = props.label.charAt(0).toUpperCase() + props.label.substring(1).toLowerCase();
  if (props.validation) {
    s += props.validation.required !== undefined ? " *" : "";
  }
  return s;
}

function defaultfilter(val: string, update: (callbackFn: any) => void) {
  update(() => {
    curOptions.value = props.options.filter((v) => searchPredicate(val.toLowerCase(), v.label));
  });
}

function objectComparer(obj1: any, obj2: any) {
  if (obj1?.equals && obj2?.equals) {
    return obj1.equals(obj2) && obj2.equals(obj1);
  }
  const obj1Keys = Object.keys(obj1 || {});
  const obj2Keys = Object.keys(obj2 || {});
  if (obj1Keys.length !== obj2Keys.length) return false;
  for (const key of obj1Keys) {
    const obj1Val = obj1[key];
    const obj2Val = obj2[key];
    if (obj1Val === undefined) {
      if (obj2Val !== undefined) return false;
    }
    if (obj1Val !== obj2Val) return false;
  }
  return true;
}
</script>
<style scoped>
.showerror {
  padding-bottom: 20px !important;
}
</style>
<style>
input[type="search" i]:enabled:read-write:-webkit-any(:focus, :hover)::-webkit-search-cancel-button {
  display: none;
  opacity: 0;
}
</style>
